import { MdCheckCircle, MdCancel, MdSchedule, MdRemoveCircleOutline, MdDeleteOutline } from "react-icons/md";
import { TemplateType } from "./models";

export const COMMS_NON_EDITABLE_STATUSES = ["delivered", "skipped", "removed"];
export const COMMS_NO_ACTION_MENU_STATUSES = ["delivered", "removed"];

export const TASK_NON_EDITABLE_STATUSES = ["completed", "skipped", "removed", "closed_stale"];
export const TASK_NO_ACTION_MENU_STATUSES = ["completed", "removed", "closed_stale"];

export const MEETING_NON_EDITABLE_STATUSES = ["completed", "skipped", "removed", "cancelled"];
export const MEETING_NO_ACTION_MENU_STATUSES = ["completed", "removed", "cancelled"];

export const UNSENT_STATUSES = ["pending", "upcoming", "active", "in_progress", "blocked", "failed"];

/**
 * Statuses indicating an action is resolved/terminal across ALL action types — either done
 * (completed/delivered) or closed without completing (skipped/removed/closed_stale/cancelled).
 * Single source of truth for the `isActionResolved()` helper.
 */
export const RESOLVED_ACTION_STATUSES = [
  "completed",
  "delivered",
  "skipped",
  "removed",
  "closed_stale",
  "cancelled",
];

/**
 * Semantic status buckets for filtering a mixed action list. Raw status values differ per
 * action type (email vs task vs meeting), so the UI filters by these cross-type groups
 * rather than exposing every raw value.
 */
export const STATUS_FILTER_GROUP_MATCHERS: Record<string, string[]> = {
  failed: ["failed"],
  completed: ["completed", "complete", "delivered"],
  in_progress: ["active", "in_progress", "blocked"],
  upcoming: ["scheduled", "pending", "upcoming", "pending_scheduling"],
  skipped: ["skipped", "closed_stale"],
  removed: ["removed", "cancelled"],
};

export const STATUS_FILTER_OPTIONS = [
  { label: "Failed", value: "failed" },
  { label: "Completed / Sent", value: "completed" },
  { label: "In Progress", value: "in_progress" },
  { label: "Upcoming", value: "upcoming" },
  { label: "Skipped", value: "skipped" },
  { label: "Removed", value: "removed" },
];

export const ACTION_TYPE_FILTER_OPTIONS = [
  { label: "Email", value: "email" },
  { label: "Meeting", value: "meeting" },
  { label: "Message", value: "message" },
  { label: "Task", value: "task" },
];

export const ALL_TEMPLATE_TYPES: TemplateType[] = [
  "email_template",
  "message_template",
  "task_template",
  "meeting_template",
  "checkpoint_template",
];

export const DEFAULT_NO_END_MINUTES = 15;

export const COMMS_STATUSES = new Map([
  ["pending", { icon: MdSchedule, color: "content.tertiary", label: "Upcoming", value: "pending" }],
  ["delivered", { icon: MdCheckCircle, color: "cdsGreen.500", label: "Delivered", value: "delivered" }],
  ["skipped", { icon: MdRemoveCircleOutline, color: "content.tertiary", label: "Skipped", value: "skipped" }],
  ["removed", { icon: MdDeleteOutline, color: "content.tertiary", label: "Removed", value: "removed" }],
  ["failed", { icon: MdCancel, color: "statusRed.text", label: "Failed", value: "failed" }],
]);

// Shared stage options for Tasks, Messages, and Emails
export const CHECK_TARGET_LABELS: Record<string, string> = {
  new_hire_tasks: "New Hire's Open Tasks",
  all_stakeholder_tasks: "Everyone's Open Tasks",
  non_new_hire_tasks: "Non-New Hire Open Tasks",
};

export const CHECK_TARGET_OPTIONS = Object.entries(CHECK_TARGET_LABELS).map(([value, label]) => ({ value, label }));

export const DELIVERY_METHOD_LABELS: Record<string, string> = {
  message: "Message (Slack)",
  email: "Email",
};

export const DELIVERY_METHOD_OPTIONS = Object.entries(DELIVERY_METHOD_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const STAGE_OPTIONS = [
  { label: "Immediate", value: "immediate" },
  { label: "Preboarding", value: "preboarding" },
  { label: "Week 1", value: "week_1" },
  { label: "Week 2", value: "week_2" },
  { label: "Month 1", value: "month_1" },
  { label: "Month 2", value: "month_2" },
  { label: "Month 3", value: "month_3" },
  { label: "3+ Months", value: "after_month_3" },
  { label: "6+ Months", value: "after_month_6" },
  { label: "Past 1 Year", value: "after_month_12" },
  { label: "After Task Completion", value: "dependency" },
];
